import { Box, Link } from '@mui/material';
import ExternalLinks from '../../../shared/externalLinks';
import Styles from './css/SupportMenuStyles';

const SupportMenu = () => {

    return (
        <Box sx={Styles.Root} >
            <Box sx={Styles.SupportMenuContainer}>
                <Box flex={4}>
                    <Box sx={Styles.SupportHeaderContainer}>
                        <Link href={ExternalLinks.MARKETING.SUPPORT.HOME} sx={Styles.SupportSectionHeader}>Self-Service Virtual Concierge</Link>
                    </Box>
                    <Box sx={Styles.SupportLinksContainer}>
                        <Box sx={Styles.SupportCategoryLinksContainer}>
                            <Link href={ExternalLinks.MARKETING.SUPPORT.GETTING_STARTED.HOME} sx={Styles.SupportLinkHeader}>Get Started</Link>
                            <Link href={ExternalLinks.MARKETING.SUPPORT.GETTING_STARTED.AFH} sx={Styles.SupportLink}>In the US, UK and Canada</Link>
                            <Link href={ExternalLinks.MARKETING.SUPPORT.GETTING_STARTED.NON_AFH} sx={Styles.SupportLink}>Outside the US, UK and Canada</Link>
                            <Link href={ExternalLinks.MARKETING.SUPPORT.GETTING_STARTED.SUBSCRIPTION_CREDITS} sx={Styles.SupportLink}>Understand credits and the self-service subscription model</Link>
                            <Link href={ExternalLinks.VCS_PORTAL.HOME} sx={Styles.SupportLink}>Login to the Virtual Concierge Portal</Link>
                        </Box>
                        <Box sx={Styles.SupportCategoryLinksContainer}>
                            <Link href={ExternalLinks.MARKETING.SUPPORT.LEARN.HOME} sx={Styles.SupportLinkHeader}>Learn</Link>
                            <Link href={ExternalLinks.MARKETING.SUPPORT.LEARN.VOICE_CONTENT} sx={Styles.SupportLink}>Voice Content</Link>
                            <Link href={ExternalLinks.MARKETING.SUPPORT.LEARN.DEVICE_MANAGEMENT} sx={Styles.SupportLink}>Device Management</Link>
                            <Link href={ExternalLinks.MARKETING.SUPPORT.LEARN.INTEGRATIONS} sx={Styles.SupportLink}>Integrations</Link>
                            <Link href={ExternalLinks.MARKETING.SUPPORT.LEARN.COMMUNICATION_FEATURES} sx={Styles.SupportLink}>Communication Features</Link>
                            <Link href={ExternalLinks.MARKETING.SUPPORT.LEARN.REPORTING_AND_ANALYTICS} sx={Styles.SupportLink}>Reporting and Analytics</Link>
                            <Link href={ExternalLinks.MARKETING.SUPPORT.LEARN.SETTINGS} sx={Styles.SupportLink}>Settings</Link>
                        </Box>
                        <Box sx={Styles.TroubleshootLinksContainer}>
                            <Link href={ExternalLinks.MARKETING.SUPPORT.TROUBLESHOOT.HOME} sx={Styles.SupportLinkHeader}>Troubleshoot</Link>
                            <Link href={ExternalLinks.MARKETING.SUPPORT.TROUBLESHOOT.AFH} sx={Styles.SupportLink}>In the US, UK and Canada</Link>
                            <Link href={ExternalLinks.MARKETING.SUPPORT.TROUBLESHOOT.NON_AFH} sx={Styles.SupportLink}>Outside the US, UK and Canada</Link>
                            <Link href={ExternalLinks.MARKETING.SUPPORT.TROUBLESHOOT.FAQ} sx={Styles.SupportLink}>FAQ</Link>
                        </Box>
                    </Box>
                </Box>
                <Box sx={Styles.HomeSectionHeader}>
                    <Box>
                        <Box sx={Styles.SupportHeaderContainer}>
                            <Link href={ExternalLinks.MARKETING.ABOUT.HOME} sx={Styles.SupportSectionHeader}>About AIPEX</Link>
                        </Box>
                        <Box sx={Styles.AboutLinksContainer}>
                            <Link href={ExternalLinks.MARKETING.ABOUT.PURPOSE} sx={Styles.SupportLink}>Purpose</Link>
                            <Link href={ExternalLinks.MARKETING.ABOUT.TEAM} sx={Styles.SupportLink}>Our Team</Link>
                            <Link href={ExternalLinks.MARKETING.ABOUT.NEWS_ROOM} sx={Styles.SupportLink}>News Room</Link>
                            <Link href={ExternalLinks.MARKETING.ABOUT.CONTACT} sx={Styles.SupportLink}>Contact Us</Link>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default SupportMenu;